import { LANGS } from '../langs';
import { Lang } from '../langs/types';

export function getLangFromUrl(): { lang: Lang; code: keyof typeof LANGS } {
    const code = window.location.pathname.split('/')[1].toLowerCase() as keyof typeof LANGS;
    const lang = LANGS[code] ?? LANGS.pl;

    return { lang, code: LANGS[code] ? code : 'pl' };
}
